module.exports = __webpack_public_path__ + "static/brandbook-photos-49198366fb227b85471db5d2bdde6804.jpg";